import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { IIssue } from 'shared';

import { IssueService } from '../issue.service';
import { SharingService } from '../sharing.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface IssueStatusUpdatedSocketEvent {
    eventDtoType: 'IssueStatusUpdated';
    issue: IIssue;
}

@Injectable({ providedIn: 'root' })
export class IssueStatusUpdatedSocketEventHandler extends BaseSocketEventHandler<IssueStatusUpdatedSocketEvent> {
    private issueService = inject(IssueService);
    private sharingService = inject(SharingService);

    protected eventDtoType(): string {
        return 'IssueStatusUpdated';
    }

    protected handleEvent = async (event: IssueStatusUpdatedSocketEvent): Promise<void> => {
        this.issueService.localUpdate(event.issue);
        // Get shared issue
        const sharedEntity = await firstValueFrom(this.sharingService.sharedEntity.pipe(take(1)));
        // Update shared issue
        if (sharedEntity && sharedEntity.type === 'SHARED_ISSUE' && sharedEntity.issue.id === event.issue.id) {
            sharedEntity.issue.status = event.issue.status;
            sharedEntity.issue.taskStatuses = event.issue.taskStatuses;
            this.sharingService.updateSharedEntity(sharedEntity);
        }
    };
}
